








import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypagePaidPlanChangeEditPane from '@/components/MypagePaidPlanChangePage/MypagePaidPlanChangeEditPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

/**
 * アプリ版: プラン変更(有料=>有料) ページ
 */
export default defineComponent({
  name: 'MypagePaidPlanChangeEditPage',
  components: {
    GlobalNavigationPane,
    SubHeaderSection,
    MypagePaidPlanChangeEditPane,
  },
})
